export const AIChatFallbackContactFragment = gql`
  fragment AIChatFallbackContactFragment on AIChatFallbackContact {
    id
    fallbackConditions
    contactString
    usageCount
    user {
      ...UserDataFragment
    }
  }
`
